var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruiseTour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 108.593,
    viewBox: "0 0 157 108.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4229",
    "data-name": "Group 4229",
    transform: "translate(-1108.707 -419.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(11.707 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 68.5,
    cy: 15.5,
    rx: 68.5,
    ry: 15.5,
    transform: "translate(1097 475)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 63.5,
    cy: 24,
    rx: 63.5,
    ry: 24,
    transform: "translate(1127 475)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M63.335,356.613l2.672-2.516,11.632-2.673L116,358.971l-4.612,1.415Z",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M27.126,368.142,58.567,390.15l86.148,1.467s4.4-11.528-.42-17.187l-2.1-7.336L75.964,353.26s-13.414,2.724-16.14,5.24-8.8,8.8-8.8,8.8Z",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M54.375,387.216l90.967,2.516-.628,1.886L58.567,390.15Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M51.021,367.3a170.555,170.555,0,0,1,26.2.629c13.415,1.467,68.121,7.756,68.121,7.756l-1.048-1.258S87.7,367.3,77.432,366.465,55.842,365.416,51.021,367.3Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M56.052,375.478a8.421,8.421,0,0,0,1.887.628c1.048.21,19.283.629,31.859,1.887s54.707,4.4,54.707,4.4,1.05-.629-.629-1.048S62.76,374.219,56.052,375.478Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M52.907,365.365l14.9-1.246,1.205-1.415-15.06,1.612Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M55.082,363.216l5.228-.629,2.239-2.62,6.708-.629.577-.943,4.611-.314,1.676-1.571-7.231.733-.577,1.152-6.811.733L60.245,360.6l-2.989.262Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M76.8,353.889l-1.258,3.563L72.4,359.338l-.839,1.677-2.1.629-.419,1.049-.583.7-.675.767L144,373.375l-1.081-3.636-.72-2.645Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4176",
    "data-name": "Group 4176",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M69.047,362.692l74.539,9.4.355,1.258-76.152-9.2Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4177",
    "data-name": "Group 4177",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M71.563,361.015l.839-1.677,70.635,10.9.276.876Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4178",
    "data-name": "Group 4178",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M74.288,358.08l1.623-1.573,66.655,11.936.237.9Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4179",
    "data-name": "Group 4179",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M76.384,355.147l.418-1.258,34.531,6.45,30.875,6.746Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4180",
    "data-name": "Group 4180",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M64.435,371.94c0,.478-.774.865-1.728.865s-1.73-.387-1.73-.865.775-.865,1.73-.865S64.435,371.463,64.435,371.94Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4181",
    "data-name": "Group 4181",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M71.2,372.019c0,.478-.775.864-1.73.864s-1.729-.386-1.729-.864.774-.865,1.729-.865S71.2,371.542,71.2,372.019Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M76.695,372.255c-.021.475-.812.827-1.766.785s-1.709-.466-1.688-.943.814-.827,1.767-.786S76.717,371.778,76.695,372.255Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4183",
    "data-name": "Group 4183",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M82.512,372.569c-.021.476-.812.828-1.766.785s-1.71-.465-1.688-.943.813-.827,1.766-.785S82.533,372.093,82.512,372.569Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4184",
    "data-name": "Group 4184",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M87.7,372.883c-.022.476-.813.828-1.768.786s-1.709-.466-1.687-.942.813-.829,1.766-.787S87.722,372.407,87.7,372.883Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M93.674,373.513c-.022.476-.813.827-1.767.785s-1.709-.466-1.687-.944.812-.827,1.765-.785S93.7,373.035,93.674,373.513Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M99.49,373.983c-.021.478-.813.828-1.766.787s-1.709-.466-1.688-.943.813-.828,1.767-.787S99.511,373.507,99.49,373.983Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4187",
    "data-name": "Group 4187",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M104.364,374.455c-.022.478-.813.829-1.767.787s-1.71-.467-1.688-.944.813-.827,1.767-.785S104.386,373.978,104.364,374.455Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4188",
    "data-name": "Group 4188",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M109.552,374.927c-.022.476-.814.828-1.767.787s-1.709-.467-1.689-.944.813-.828,1.768-.787S109.573,374.451,109.552,374.927Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4189",
    "data-name": "Group 4189",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M114.582,375.4c-.022.478-.813.83-1.768.787s-1.708-.467-1.686-.943.812-.828,1.766-.787S114.6,374.922,114.582,375.4Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M119.77,376.027c-.022.478-.812.828-1.767.787s-1.709-.467-1.689-.943.814-.828,1.768-.787S119.792,375.551,119.77,376.027Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M124.6,376.514c-.02.445-.756.771-1.644.732s-1.591-.433-1.571-.878.757-.77,1.645-.731S124.624,376.07,124.6,376.514Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M129.2,376.814c-.019.443-.754.769-1.639.729s-1.586-.433-1.565-.874.753-.769,1.638-.73S129.222,376.372,129.2,376.814Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4193",
    "data-name": "Group 4193",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M133.29,377.129c-.021.424-.725.736-1.573.7s-1.522-.415-1.5-.84.724-.737,1.572-.7S133.308,376.7,133.29,377.129Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M137.376,377.443c-.018.41-.7.715-1.524.678s-1.473-.4-1.454-.814.7-.714,1.524-.678S137.4,377.031,137.376,377.443Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4195",
    "data-name": "Group 4195",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M141.852,377.772c-.021.45-.768.78-1.667.739s-1.613-.44-1.593-.889.767-.781,1.667-.74S141.872,377.319,141.852,377.772Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M145.689,378.162c-.017.383-.649.663-1.413.629s-1.367-.372-1.35-.754.651-.663,1.414-.628S145.707,377.781,145.689,378.162Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4197",
    "data-name": "Group 4197",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M76.8,353.889l-12.261,1.728-1.206,1,13.049-1.467Z",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4198",
    "data-name": "Group 4198",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5767",
    "data-name": "Path 5767",
    d: "M93.781,362.64,93.047,364l3.459.524.472-1.414Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5768",
    "data-name": "Path 5768",
    d: "M109.291,365.051l-.314,1.151,6.76,1,.314-1.1Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5769",
    "data-name": "Path 5769",
    d: "M99.912,366.623l-.419,1.309,20.28,2.516.262-1.364Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4201",
    "data-name": "Group 4201",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M132.715,370.762l-.263,1.1,10.585,1.311-.208-1.1Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4202",
    "data-name": "Group 4202",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M74.288,358.08,72.4,359.338l-.839,1.677-2.1.629-9.118.9,2.2-2.58,6.721-.682.564-.891Z",
    fill: "#3b55eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4203",
    "data-name": "Group 4203",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M31.791,369.686l18.657,12.97s-7.964-8.874-6.143-12.97Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M50.277,382.543l5.46,4.1,64.62,2.5S61.881,386.411,50.277,382.543Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5774",
    "data-name": "Path 5774",
    d: "M37.835,393.034c.018-.352,17.657,1.815,39.365,5.543s39.7-1.262,39.718-1.614c-.044.866-17.814,1.359-39.363-5.544S37.879,392.168,37.835,393.034Z",
    fill: "#e7f8fd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5775",
    "data-name": "Path 5775",
    d: "M152.495,395.34c0-.454-20.783,1.2-46.416,4.608S59.663,395.8,59.663,395.34c0-.224,5.194,1.53,13.6,1.052,8.4-.233,20-2.7,32.821-5.659s24.421-3.122,32.821-1.05A44.289,44.289,0,0,1,152.495,395.34Z",
    transform: "translate(1081.189 99.146)",
    fill: "#e7f8fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4207",
    "data-name": "Group 4207",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M69.4,394c-.016-.328,11.89.31,26.621,2.08s26.324-4.245,26.308-4.572a24.872,24.872,0,0,1-7.716,1.123c-4.8.059-11.5-1.409-18.9-3.2s-14.03-1.6-18.749.123A23.017,23.017,0,0,0,69.4,394Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M123.929,394.836c.012-.169,4.664.744,10.368,2.374a14.239,14.239,0,0,0,10.585-1.042,7.784,7.784,0,0,1-3.093.194,27.972,27.972,0,0,1-7.275-2.57,10.357,10.357,0,0,0-7.383-.86A8.888,8.888,0,0,0,123.929,394.836Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(1081.189 99.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M52.941,395.859c.011-.168,4.663.745,10.368,2.375a14.248,14.248,0,0,0,10.585-1.043,7.743,7.743,0,0,1-3.093.2,27.89,27.89,0,0,1-7.275-2.572,10.368,10.368,0,0,0-7.383-.859A8.882,8.882,0,0,0,52.941,395.859Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3116",
    "data-name": "Rectangle 3116",
    width: 6.957,
    height: 6.957,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 1118.479, 441.886)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M129.914,40.807a3.207,3.207,0,1,1-3.207-3.207A3.181,3.181,0,0,1,129.914,40.807Z",
    transform: "translate(1061.5 385.557)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M76.366,192.249l2.282-7.849L71.3,187.072Z",
    transform: "translate(1027.748 499.871) rotate(-82)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4212",
    "data-name": "Group 4212",
    transform: "translate(-22.871 -14.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    transform: "translate(1259.205 439.85)",
    fill: "#c4cdfa",
    stroke: "#536dfe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.196,
    cy: 7.196,
    r: 7.196,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.196,
    cy: 7.196,
    r: 6.696,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4211",
    "data-name": "Group 4211",
    transform: "translate(1252.855 433.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_570",
    "data-name": "Line 570",
    y2: 5.08,
    transform: "translate(13.546)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_571",
    "data-name": "Line 571",
    y2: 5.08,
    transform: "translate(13.546 22.013)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_576",
    "data-name": "Line 576",
    y2: 5.08,
    transform: "translate(7.196 25.278) rotate(-150)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_577",
    "data-name": "Line 577",
    y2: 5.08,
    transform: "translate(18.203 6.214) rotate(-150)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_580",
    "data-name": "Line 580",
    y2: 5.08,
    transform: "translate(2.239 6.773) rotate(-60)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_582",
    "data-name": "Line 582",
    y2: 5.08,
    transform: "translate(20.743 25.277) rotate(150)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_581",
    "data-name": "Line 581",
    y2: 5.08,
    transform: "translate(21.302 17.78) rotate(-60)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_583",
    "data-name": "Line 583",
    y2: 5.08,
    transform: "translate(9.736 6.214) rotate(150)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_584",
    "data-name": "Line 584",
    y2: 5.08,
    transform: "translate(0 13.546) rotate(-90)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_586",
    "data-name": "Line 586",
    y2: 5.08,
    transform: "translate(2.239 20.319) rotate(-120)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_585",
    "data-name": "Line 585",
    y2: 5.08,
    transform: "translate(22.013 13.546) rotate(-90)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_587",
    "data-name": "Line 587",
    y2: 5.08,
    transform: "translate(21.302 9.313) rotate(-120)",
    fill: "none",
    stroke: "#536dfe",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruiseTour);
export default __webpack_public_path__ + "static/media/cruise-tour.c000d60a.svg";
export { ForwardRef as ReactComponent };